import type { FilterSection } from "@/types/filter";
// import defaultBooleanOptions from "@/utils/constants/defaultBooleanOptions";
import monthsFilterOption from "@/utils/constants/monthsFilterOption";
import yearsFilterOption from "@/utils/constants/yearsFilterOption";

const FILTER_SECTIONS: FilterSection[] = [
  //   {
  //   key: 'landingPageAfsaProgramme',
  //   label: 'Is On Landing Page?',
  //   type: 'boolean',
  //   options: defaultBooleanOptions,
  //   placeholder: 'Select an option',
  // },
 {
    key: 'year',
    label: 'Year',
    type: 'select',
    options: yearsFilterOption,
  },
  {
    key: 'month',
    label: 'Month',
    type: 'select',
    options: monthsFilterOption,
  },
  //   {
  //   key: 'createdStartDate',
  //   label: "Created At (Start Date)",
  //   type: 'date',
  //   placeholder: 'Select a start date',
  // },
  // {
  //   key: 'createdEndDate',
  //   label: "Created At (End Date)",
  //   type: 'date',
  //   placeholder: 'Select an end date',
  // },
  // {
  //   key: 'publishedStartDate',
  //   label: "Published At (Start Date)",
  //   type: 'date',
  //   placeholder: 'Select a start date',
  // },
  // {
  //   key: 'publishedEndDate',
  //   label: "Published At (End Date)",
  //   type: 'date',
  //   placeholder: 'Select an end date',
  // },
];

export default FILTER_SECTIONS;